
<fc-content-header-summary [content]="content"  [analyticsMode]="analyticsMode">
    <div class="fc-accordion-item" *ngFor="let c of content.components; index as i;">
        <h3 [innerHtml]="c.heading" (click)="onClick($event)"></h3>
        <div class="fc-accordion-content" [innerHtml]="c.content | marked: analyticsMode"></div>
    </div>
</fc-content-header-summary>